window.flutterChannelCall = function (channel, payload) {};

if (navigator.userAgent.includes("XFPAPP")) {
  let resolveFlutterReady;
  window.flutterReady = new Promise((resolve) => {
    resolveFlutterReady = resolve;
  });

  if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
    resolveFlutterReady();
  } else {
    window.addEventListener("flutterInAppWebViewPlatformReady", () => {
      resolveFlutterReady();
    });
  }

  window.flutterChannelCall = function flutterChannelCall(channel, payload) {
    window.flutterReady.then(() => {
      window.flutter_inappwebview
        .callHandler(channel, payload)
        .then((result) => {
          console.log("Flutter handler result:", JSON.stringify(result));
        })
        .catch((error) => {
          console.error("Error calling Flutter handler:", error);
        });
    });
  };

  window.addEventListener("onpageswap", (event) => {
    event.stopImmediatePropagation();
    event.preventDefault();
    const origin = window.location.origin;
    const url = new URL(document.activeElement.href);
    const destination = url.origin;
    const pathname = origin === destination ? url.pathname : "external";
    const pathnameArray = pathname.split("/");
    pathnameArray.forEach((uri) => {
      let channel;
      let payload = {};

      switch (uri) {
        case "external":
          channel = "url";
          payload = {
            action: "open",
            data: {
              url,
            },
          };
          break;
        case "cart":
          channel = "cart";
          payload = {
            action: "open",
          };
          break;
        case "sign-in":
          channel = "signin";
          payload = {
            action: "open",
            data: {
              return_url: window.location.pathname,
            },
          };
          break;
        case "sign-up":
          channel = "signup";
          payload = {
            action: "open",
            data: {
              return_url: window.location.pathname,
            },
          };
          break;
        case "products":
          channel = "product";
          payload = {
            action: "open",
            data: pathnameArray[1] ?? "",
          };
          break;
        case "collections":
          channel = "list";
          payload = {
            action: "open",
            data: pathnameArray[1] ?? "",
          };
          break;
        case "following":
        case "saved-searches":
          channel = "wishlist";
          payload = {
            action: "open",
          };
          break;
        case "sell-your-bag":
          ((channel = "seller"),
            (payload = {
              action: "open",
            }));
          break;
        default:
          return;
      }
      if (channel) {
        flutterChannelCall(channel, payload);
      }
    });
  });

  // Mobile app click events
  document.addEventListener("DOMContentLoaded", () => {
    const elementsWithDataChannel = document.querySelectorAll("[data-channel]");
    elementsWithDataChannel.forEach((element) => {
      const channel = element.getAttribute("data-channel");
      const action = element.getAttribute("data-action");

      const title = element.getAttribute("data-title");
      const url = element.getAttribute("data-url");

      element.addEventListener("click", function (event) {
        event.stopImmediatePropagation();
        event.preventDefault();

        let payload = {};

        switch (channel) {
          case "share":
            payload = {
              action,
              data: {
                title: title || "",
                url: url || "",
              },
            };
            break;
          case "reserve-payment":
            let reserveCartId = getCartIdFromCookie();
            payload = {
              action,
              data: {
                cartId: reserveCartId || "",
              },
            };
            break;
          default:
            return;
        }

        if (channel) {
          flutterChannelCall(channel, payload);
        }
      });
    });
  });

  (async () => {
    const clerkLoaded = await window.isClerkLoaded();
    flutterChannelCall("authentication", {
      action: "clerk-loaded",
      clerkLoaded: clerkLoaded,
      clerkUserId: window?.Clerk?.user?.id,
      customerId: window.customerId,
      customerEmail: window.customerEmail,
      customerFirstName: window.customerFirstName,
      customerLastName: window.customerLastName,
      customerCreatedAt: window.customerCreatedAt,
    });
  })();
}
